<template lang="pug">
div
  router-view
  v-dialog(width="660", v-model="payDialog")
    PaySelection(:open="payDialog", @close="payDialog = false")
</template>

<script>
import PaySelection from "@/components/Cases/CaseTable/PaySelection";

export default {
  name: "employer-cases",

  components: {
    PaySelection,
  },

  data: () => ({}),

  computed: {
    payDialog: {
      get() {
        return this.$store.state.payDialog;
      },
      set(v) {
        this.$store.commit("setPayDialog", v);
      },
    },
  },

  methods: {},
};
</script>